export default __webpack_public_path__ + "static/media/footer-bg-second.be6a505d.svg";